export default "__VITE_ASSET__90b1aae6__"